"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Catalog = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var CategoryDish_1 = require("./CategoryDish");
var CategoryList_1 = require("./CategoryList");
require("./catalog.scss");
var Filters_1 = require("./Filters");
exports.Catalog = react_1.default.memo(function (_a) {
    var menuList = _a.menuList, categories = _a.categories;
    var categoryRefs = (0, react_1.useRef)([]);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: 'catalog' }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: 'catalog-container' }, { children: [(0, jsx_runtime_1.jsx)(Filters_1.Filters, { menuList: menuList }), (0, jsx_runtime_1.jsx)(CategoryList_1.CategoryList, { categoryRefs: categoryRefs, categories: categories })] })), (0, jsx_runtime_1.jsx)("div", __assign({ className: 'products' }, { children: categories === null || categories === void 0 ? void 0 : categories.map(function (category, i) { return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: 'product-wrapper', ref: function (el) { return (categoryRefs.current[i] = el); } }, { children: [(0, jsx_runtime_1.jsx)("h2", __assign({ className: 'category-header' }, { children: category.name })), (0, jsx_runtime_1.jsx)("div", __assign({ className: 'category-product-list' }, { children: category.dishes.map(function (dish) { return ((0, jsx_runtime_1.jsx)(CategoryDish_1.CategoryDish, { dish: dish }, dish.id)); }) }))] }), category.id)); }) }))] })) }));
});
